var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector43(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18H4.5V16.5H11.25C13.3177 16.5 15 14.8177 15 12.75V3.75H16.5V12.75C16.5 15.6442 14.145 18 11.25 18ZM11.25 0H9V0.75C9 1.99275 7.99275 3 6.75 3C5.50725 3 4.5 1.99275 4.5 0.75V0H2.25C1.0095 0 0 1.0095 0 2.25V12.75C0 13.9905 1.0095 15 2.25 15H4.5V14.25C4.5 13.0072 5.50725 12 6.75 12C7.99275 12 9 13.0072 9 14.25V15H11.25C12.4905 15 13.5 13.9905 13.5 12.75V2.25C13.5 1.0095 12.4905 0 11.25 0Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector43);
export default __webpack_public_path__ + "static/media/Vector (43).872fb2237fccb4f5024d3c3109fee193.svg";
export { ForwardRef as ReactComponent };